import React from 'react';
import Proptypes from 'prop-types';
import { getSaxsExperimentByExperimentId } from './IORequests';
import { parseExperiment } from '../../../helpers/Saxs/SaxsExperimentsMapper';

/**
 * React container which retrieve an experiment by experimentId
 * CURRENTLY not used
 */
class SaxsExperimentContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            experiment: null,
            experimentId: null,
            error: null,
            fetched: false,
            fetching: true,
        }

        this.getExperiment = this.getExperiment.bind(this);
    }

    render() {
        if (this.props.experimentId) {
            if (this.props.experimentId !== this.state.experimentId) {
                if (this.state.fetching === false) {
                    this.setState({ fetching: true, fetched: false })
                }
                this.getExperiment();
            }
        }
        return this.props.children(this.state.experiment, this.state.fetching, this.state.fetched);
    }

    getExperiment() {
        const onSuccess = (response) => {
            this.setState({ experiment: parseExperiment(response.data[0]), experimentId: this.props.experimentId, fetching: false, fetched: true });
        };

        const onError = (error) => {
            this.setState({ error: error, fetching: false, fetched: false });
        };

        getSaxsExperimentByExperimentId(this.props.token, this.props.proposal, this.props.experimentId, onSuccess, onError);
    }
}

SaxsExperimentContainer.proptypes = {
    /** experiment identifier to get the details from*/
    experimentId: Proptypes.string,
    /** proposal name */
    proposal: Proptypes.string,
    /** ispyb authentication token */
    token: Proptypes.string,
}

export default SaxsExperimentContainer;


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsExperimentContainer.js